import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  isLoggedIn = false;

  accoundId: number = 0;
  username?: string;
  first_name?: string;
  last_name?: string;
  currentRoute: string = "";
  
  constructor(
    private authService: AuthService, 
    private tokenStorage: TokenStorageService, 
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;

      this.tokenStorage.getUserInfo().subscribe({
        next: (data: any) => {
          this.username = data.login;
          this.accoundId = data.account_id;
          this.first_name = data.first_name;
          this.last_name = data.last_name;
        },
        error: (err: any) => {
          console.log("Something went wrong getting the user info: ", err)
          this.logout();
        }
      });

    }

  }


  logout(): void {
    this.isLoggedIn = false;
    localStorage.removeItem("token");
    this.router.navigate(['/'])
  }

}
